import React from 'react';
import { Chip } from '@mui/material';

const STATUS_CONFIG = {
  ABIERTO: { label: 'Abierto', color: 'primary' },
  CERRADO: { label: 'Cerrado', color: 'info' },
  FACTURADO: { label: 'Facturado', color: 'success' },
  ANULADO: { label: 'Anulado', color: 'error' },
};

const AlbaranEstadoBadge = ({ estado }) => {
  const config = STATUS_CONFIG[estado] || { label: estado, color: 'default' };
  return <Chip label={config.label} color={config.color} size="small" sx={{ fontWeight: 'bold' }} />;
};

export default AlbaranEstadoBadge;